<app-card #card 
    [cardTitle]="'CONTACT.TITLE' | translate" 
    [formGroup]="detailForm"
    *ngIf="model$ | async as model" 
    (ok)="save()">

    <div class="flex-vertical" slot="edit">
        <mat-form-field appearance="outline">
            <mat-label>{{ 'CONTACT.EMAIL' | translate }}</mat-label>
            <input matInput formControlName="email" autocomplete="off">
            <mat-error msg></mat-error>
        </mat-form-field>
    </div>

    <div slot="readonly">
        <app-read-only-field icon="email" [label]="'CONTACT.EMAIL' | translate" [value]="model.email"></app-read-only-field>
    </div>

</app-card>
